// @flow

// Hocs
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

// Selectors
import contactUs$ from '../selectors/contactUs'

// components
import ContactUsForm from '../components/ContactUs'

// Operator
import composeContactUsOperator from 'hfty-operator-contact-us'

const contactUsOperator = composeContactUsOperator()

function mapStateToProps (state: *): * {
  return {
    operation: contactUs$(state),
  }
}

type MapDispatchToProps = {
  actions: {
    onEdit: Function,
  }
}

function mapDispatchToProps (dispatch: Dispatch<*>): MapDispatchToProps {
  return {
    actions: bindActionCreators({
      onChange: contactUsOperator.actionCreators.updateOperation,
      onCancel: contactUsOperator.actionCreators.cancelOperations,
      onSubmit: contactUsOperator.actionCreators.submitOperations,
    }, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactUsForm)
